import { useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import { useActionModule } from './hooks/useActionModule'
import ActionModuleEditor from './editor/ActionModuleEditor'

// Full action-module wizard. Two scopes (see `useActionModuleMutations`):
// - `isAdmin`: URL carries `:companyId` → administration endpoints (create/edit/delete).
// - CMU (`!isAdmin`): no `:companyId` → `companies/current` endpoints (edit-only).
export default function ActionModuleEditorPage({ isAdmin = false }: { isAdmin?: boolean }) {
  const { t } = useTranslation('action-modules-wizard')
  const { companyId, actionModuleId } = useParams<{ companyId?: string; actionModuleId?: string }>()
  const navigate = useNavigate()

  const cid = isAdmin && companyId ? Number(companyId) : undefined
  const amId = actionModuleId && actionModuleId !== 'new' ? Number(actionModuleId) : undefined
  const { isLoading, actionModule } = useActionModule({ isAdmin, companyId: cid, actionModuleId: amId })

  const back = () => navigate('/action-modules')

  return (
    <PageLayout>
      <PageHeader title={amId ? (actionModule?.name ?? t('page.moduleFallback')) : t('page.newTitle')} />
      <ActionModuleEditor
        isAdmin={isAdmin}
        companyId={cid}
        actionModuleId={amId}
        actionModule={actionModule}
        isLoading={isLoading}
        onSaved={back}
        onDeleted={back}
      />
    </PageLayout>
  )
}
